var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ItemBase } from '../../models/item/item-base';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { ViewComponent } from '../view/view.component';
import { ContentBaseService } from '../base/contentbase.service';
import { PageService } from '../../models/page.service';
var EditMessagesComponent = /** @class */ (function (_super) {
    __extends(EditMessagesComponent, _super);
    function EditMessagesComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        return _this;
    }
    EditMessagesComponent.prototype.ngOnInit = function () {
        this.action.setRec(this.message.getMetaMessages());
        _super.prototype.ngOnInit.call(this);
    };
    EditMessagesComponent.prototype.onSubscribe = function (data) {
        if (typeof data.items !== 'undefined') {
            this.setData(data.items);
        }
        _super.prototype.setCompRec.call(this);
        this.action.setRec(this.rec);
    };
    EditMessagesComponent.prototype.setData = function (data) {
        this.cols = [];
        this.rec = {};
        for (var i = 0; i < data.length; i++) {
            var col = {
                key: data[i].message_id,
                label: data[i].message_id,
                controlType: 'text',
                params: { note: data[i].default_value }
            };
            this.cols.push(Object.assign(new ItemBase(), col));
            this.rec[data[i].message_id] = data[i].current_value;
        }
        this.dispRec = this.rec;
    };
    EditMessagesComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    EditMessagesComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'editmessages',
                    template: "<form *ngIf=\"defMode === '' || defMode === mode\" id=\"{{ componentName }}\">\n  <ng-template ngFor let-col [ngForOf]=\"cols\" let-index=\"index\" [ngForTrackBy]=\"trackByCol\">\n    <ng-template [ngIf]=\"col.readonly || (!col.readonly && !col.hidden)\" [ngIfElse]=\"elseBlock\">\n      <div class=\"row\" [class.-mb-1]=\"index < cols.length - 1\">\n        <div class=\"col-sm-12\">\n          <column [key]=\"'form'\" [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\" (clickCol)=\"onClick($event)\"></column>\n        </div>\n      </div>\n    </ng-template>\n    <ng-template #elseBlock>\n      <columngroup [componentName]=\"componentName\" [col]=\"col\" [val]=\"dispRec\" (changeVal)=\"onChange($event)\"></columngroup>\n    </ng-template>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    EditMessagesComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return EditMessagesComponent;
}(ViewComponent));
export { EditMessagesComponent };
//# sourceMappingURL=editmessages.component.js.map